module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.displayError) ? _c('p', {
    staticClass: "error-box"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.displayError))]) : _vm._e(), _vm._v(" "), (_vm.isLoading && _vm.agreements.length == 0) ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.agreements), function(agreement, index) {
    return _c('div', {
      key: index
    }, [_c('agreement', {
      attrs: {
        "agreement": agreement
      },
      on: {
        "reload-all-agreements": function($event) {
          _vm.loadAgreements()
        }
      }
    })], 1)
  }), _vm._v(" "), (!_vm.isLoading && _vm.agreements && _vm.agreements.length == 0) ? _c('section', [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n      žádné smlouvy\n    ")])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bf7ec0e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyAgreements.vue
// module id = 314
// module chunks = 1 2